// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1aa14","formClass":"styles-module__formClass___1FVdx"};